// ============================================================
// หน้า WaterPaymentInfo — ข้อมูลค่าใช้จ่ายและการจัดเก็บค่าใช้จ่ายทั้งหมด
// ------------------------------------------------------------
// ตารางภาพรวมของทุกห้อง: ยอดงวดปัจจุบัน + ยอดค้างสะสม + เลขที่ใบเสร็จล่าสุด
// กดปุ่มหน้าแถวเพื่อไปหน้า "ตัดหนี้" ของห้องนั้น
//
// วิธีรวมยอดเหมือนหน้า Billing (ใช้ตรรกะเดียวกันจาก components/custom/bill-fields.js)
//   1. ตัดช่องที่เก็บเงินไปแล้ว/ตัดหนี้แล้วเป็น 0
//   2. จัดกลุ่มตาม (บ้านเลขที่ + ผู้ถือกรรมสิทธิ์)
//        ใบล่าสุด → total_amount | ใบเก่ากว่า → สะสมเป็น overdue_amount
// ============================================================

import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import Select from "react-select";

import Navbar from "../../shared/layout/Navbar.js";
import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import { tokens, select_style, toFixed, GET, format_date, getStorage, loading, applyWaived, unpaidAmount, addressSorter, ICON } from "../../shared/index.js";

// จำนวนแถวต่อหน้า (แบ่งหน้าฝั่งเบราว์เซอร์ เพราะต้องรวมยอดจากข้อมูลทั้งหมดก่อน)
const PAGE_SIZE = 10;

export default class WaterPaymentInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      filter_address_number: null,
      data: null, // ข้อมูลที่รวมยอดแล้ว
      data_address: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.GetAddressAll();
    await this.GetAll();
  }

  // ---------- โหลดข้อมูล ----------

  GetAddressAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_address: result.data.data.map((item) => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  GetAll = async () => {
    loading(true);
    const res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, { address_number: this.state.filter_address_number?.value || "" });
    if (!res?.status) {
      loading(false);
      return;
    }

    const rawData = res.data.data_water || [];
    // ตัดช่องที่เก็บเงิน/ตัดหนี้ไปแล้วเป็น 0 พร้อม sync s_* ให้ตรงกับลิสต์จริง
    // (ต้อง sync ด้วย เพราะ unpaidAmount() ด้านล่างอ่าน s_* — ถ้าปล่อยค่าเดิมจาก backend
    //  งวดที่ถูกยกเลิกการตัดหนี้/ยกเลิกใบเสร็จไปแล้วจะยังถูกหักออกจากยอดค้าง)
    rawData.forEach((item) => applyWaived(item));

    // เรียงใบล่าสุดขึ้นก่อน เพื่อให้ใบแรกของแต่ละกลุ่มเป็นงวดปัจจุบัน
    rawData.sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));

    // จัดกลุ่มตามห้อง + ผู้ถือกรรมสิทธิ์
    const groupedData = Object.values(
      rawData.reduce((acc, item) => {
        const key = `${item.address_number}_${item.ref_customer_id}`;
        const baseAmount = unpaidAmount(item);
        const itemLateFee = !item.s_late_payment ? Number(item.late_payment || 0) : 0;

        if (!acc[key]) {
          acc[key] = { ...item, count_installment: 1, total_amount: baseAmount, overdue_amount: 0, late_payment: itemLateFee };
        } else {
          acc[key].count_installment += 1;
          acc[key].overdue_amount += baseAmount;
          acc[key].meter_connect_cost += Number(item.meter_connect_cost || 0);
        }
        return acc;
      }, {})
    );

    this.setState({ data: groupedData.sort(addressSorter()) });
    loading(false);
  };

  render() {
    const { data, filter_address_number, data_address, page } = this.state;
    const fmt = (value) => (value ? toFixed(value) : "0.00");
    const rows = data?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE) || [];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลค่าใช้จ่ายและการจัดเก็บค่าใช้จ่ายทั้งหมด" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <h4 className="mb-3">
                <b>ข้อมูลค่าใช้จ่ายและการจัดเก็บค่าใช้จ่ายทั้งหมด</b>
              </h4>

              {/* ตัวกรอง */}
              <div className="d-flex row mx-0 mb-3">
                <Select className="form-control bg-contain border-0 select-search wpx-200 mx-1" styles={select_style} options={data_address} onChange={(e) => this.setState({ filter_address_number: e })} value={filter_address_number} />
                <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                  ค้นหา
                </button>
                <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>
                  รีเซ็ท
                </button>
              </div>

              <div className="table-responsive">
                <table className="table table-borderless table-striped text-nowrap">
                  <thead className="bg-dark-blue text-white">
                    <tr className="bg-primary">
                      <th className="text-center">ตัดลูกหนี้</th>
                      <th className="text-left">บ้านเลขที่</th>
                      <th className="text-left">ชื่อ-นามสกุล</th>
                      <th className="text-center">วันที่จดมาตร</th>
                      <th className="text-right">เลขมาตรครั้งนี้</th>
                      <th className="text-right">เลขมาตรครั้งก่อน</th>
                      <th className="text-right">จำนวนหน่วยที่ใช้</th>
                      <th className="text-right">ค่าน้ำประปา</th>
                      <th className="text-right">ค่ารักษาอุปกรณ์น้ำ</th>
                      <th className="text-right">ค่าส่วนกลาง</th>
                      <th className="text-right">ค่าขยะ</th>
                      <th className="text-right">ค่าเคเบิล</th>
                      <th className="text-right">ค่าใช้จ่ายอื่นๆ</th>
                      <th className="text-right">ค่าเบี้ยประกัน</th>
                      <th className="text-right">เพิ่ม/ลดหนี้</th>
                      <th className="text-right">ค่าต่อกลับมิเตอร์</th>
                      <th className="text-right">ค่าปรับชำระล่าช้า</th>
                      <th className="text-right">รวม (บาท)</th>
                      <th className="text-center">งวด</th>
                      <th className="text-right">จำนวนเงินค้างชำระ</th>
                      <th className="text-right">รวมเป็นเงิน</th>
                      <th className="text-left">เลขที่รับใบเสร็จ</th>
                      <th className="text-center">วันที่ใบเสร็จรับเงิน</th>
                      <th className="text-left">รายละเอียด</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.length ? (
                      <tr>
                        <td colSpan={21} className="text-center py-3">
                          {" "}
                          ไม่มีข้อมูล{" "}
                        </td>
                      </tr>
                    ) : (
                      rows.map((item, index) => (
                        <tr key={index}>
                          {/* ปุ่มไปหน้าตัดหนี้ของห้องนี้ */}
                          <td className="text-center">
                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer" onClick={() => (window.location.href = `/write-of-dept?address_number=${item.address_number}`)}>
                              <span className="icon text-primary">{ICON.building}</span>
                            </label>
                          </td>
                          <td className="text-left">{item.address_number || "-"}</td>
                          <td className="text-left">{item.full_name || "-"}</td>
                          <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-"}</td>
                          <td className="text-right">{item.current_gauge_number || "0"}</td>
                          <td className="text-right">{item.last_gauge_number || "0"}</td>
                          <td className="text-right">{item.unit_used || "0"}</td>
                          <td className="text-right">{fmt(item.water_bill)}</td>
                          <td className="text-right">{fmt(item.equipment_maintenance_fee)}</td>
                          <td className="text-right">{fmt(item.common_expenses)}</td>
                          <td className="text-right">{fmt(item.waste_cost)}</td>
                          <td className="text-right">{fmt(item.cable_cost)}</td>
                          <td className="text-right">{fmt(item.other_income)}</td>
                          <td className="text-right">{fmt(item.fire_cost)}</td>
                          <td className="text-right">{fmt((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                          <td className="text-right">{fmt(item.meter_connect_cost)}</td>
                          <td className="text-right">{fmt(item.late_payment)}</td>
                          <td className="text-right">{fmt(item.total_amount)}</td>
                          <td className="text-center">{item.count_installment || "0"}</td>
                          <td className="text-right">{toFixed(item.overdue_amount || 0)}</td>
                          <td className="text-right">{toFixed((item.total_amount || 0) + (item.overdue_amount || 0))}</td>
                          <td className="text-center">{item.ref_iw_number || "-"}</td>
                          <td className="text-center">{item.ref_datetime_bill ? format_date(item.ref_datetime_bill, "dd/mm/yyyy") : "-"}</td>
                          <td className="text-left">-</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* แบ่งหน้าฝั่งเบราว์เซอร์ — ไม่ต้องยิง API ซ้ำ */}
              {data?.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                  <label>
                    แสดง {(page - 1) * PAGE_SIZE + 1} ถึง {Math.min(page * PAGE_SIZE, data.length)} รายการ จาก {data.length} รายการ
                  </label>
                  <Pagination count={Math.ceil(data.length / PAGE_SIZE)} page={page} color="primary" showFirstButton showLastButton onChange={(e, value) => this.setState({ page: value })} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
